import React from 'react';
import { Entity } from './types';

export interface IFocusedEntityContext {
  focusedEntity: Entity | 'All';
  setFocusedEntity: React.Dispatch<React.SetStateAction<Entity | 'All'>>;
}

const FocusedEntityContext = React.createContext<IFocusedEntityContext>(null);

export const useFocusedEntityContext = () => React.useContext(FocusedEntityContext);

export const withFocusedEntityContext = (WrappedComponent) => (props) => {
  const [focusedEntity, setFocusedEntity] = React.useState<Entity | 'All'>();

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <FocusedEntityContext.Provider value={{ focusedEntity, setFocusedEntity }}>
      <WrappedComponent {...props} />
    </FocusedEntityContext.Provider>
  );
};
